// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.crypto-guard-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.crypto-guard-checking {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
}

.crypto-guard-error-content {
  text-align: center;
  padding: 40px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  margin: 20px;
}

.crypto-guard-error-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.crypto-guard-error-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
}

.crypto-guard-error-message {
  font-size: 16px;
  color: #555;
  margin-bottom: 8px;
  line-height: 1.5;
}

.crypto-guard-error-detail {
  font-size: 13px;
  color: #888;
  font-family: monospace;
  background: #f8f8f8;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 24px;
  word-break: break-word;
  text-align: left;
}

.crypto-guard-troubleshooting {
  text-align: left;
  background-color: #f8f9fa;
  border-radius: 6px;
  padding: 20px;
  margin-top: 16px;
}

.crypto-guard-troubleshooting h3 {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}

.crypto-guard-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.crypto-guard-list li {
  padding: 8px 0;
  border-bottom: 1px solid #e9ecef;
  font-size: 14px;
  color: #555;
  line-height: 1.5;
}

.crypto-guard-list li:last-child {
  border-bottom: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/CryptoIntegrityGuard.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,8EAA8E;AAChF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".crypto-guard-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #f5f5f5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.crypto-guard-checking {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.7);\n  z-index: 9999;\n}\n\n.crypto-guard-error-content {\n  text-align: center;\n  padding: 40px;\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  max-width: 600px;\n  margin: 20px;\n}\n\n.crypto-guard-error-icon {\n  font-size: 48px;\n  margin-bottom: 16px;\n}\n\n.crypto-guard-error-title {\n  font-size: 24px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 16px;\n}\n\n.crypto-guard-error-message {\n  font-size: 16px;\n  color: #555;\n  margin-bottom: 8px;\n  line-height: 1.5;\n}\n\n.crypto-guard-error-detail {\n  font-size: 13px;\n  color: #888;\n  font-family: monospace;\n  background: #f8f8f8;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  padding: 8px 12px;\n  margin-bottom: 24px;\n  word-break: break-word;\n  text-align: left;\n}\n\n.crypto-guard-troubleshooting {\n  text-align: left;\n  background-color: #f8f9fa;\n  border-radius: 6px;\n  padding: 20px;\n  margin-top: 16px;\n}\n\n.crypto-guard-troubleshooting h3 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  margin-bottom: 12px;\n}\n\n.crypto-guard-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.crypto-guard-list li {\n  padding: 8px 0;\n  border-bottom: 1px solid #e9ecef;\n  font-size: 14px;\n  color: #555;\n  line-height: 1.5;\n}\n\n.crypto-guard-list li:last-child {\n  border-bottom: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
